export const  LOCAL_STOAGE_KEYS = {
  LOCAL_STORAGE_LANGUAGE: 'user_lang'
};
